// @flow
import React, { PureComponent } from 'react';
import type { FullUserType } from 'types/User';
// import { nullParionsSportCote } from 'types/Settings';
//import type { ParionsSportCoteType } from 'types/Settings';
import { getPublicAssets } from 'utils/assetsUtils';
import { formatHours, getDateFromString, formatFullDateString } from 'utils/dateUtils';
import { handleTagEvent } from 'utils/tagManagerUtils';
import BackgroundImage from 'components/fragments/BackgroundImage';
// import ParionsSportCote from 'containers/parionsSport/ParionsSportCoteContainer';

export type StateProps = {
  userPref: FullUserType,
  //parionsSportCote: ParionsSportCoteType
};

type Props = StateProps & { datas: Object };

class TeamMenuNextMatch extends PureComponent<Props> {
  onBilletterieClick = (adversaire: string, reception: number) => {
    const { userPref } = this.props;
    const matchTitle = reception ? `France-${adversaire}` : `${adversaire}-France`;

    return handleTagEvent('billet_match', 'achat_billet', matchTitle, userPref);
  };

  render() {
    // const { title } = this.props.datas;
    const {
      date_rencontre,
      adversaire,
      billetterie,
      link,
      competition,
      embleme_france,
      embleme_adversaire,
      reception,
      lieu,
      featured_media
    } = this.props.datas.prochaine_rencontre;
    const url_attributes = billetterie ? { target: '_blank', rel: 'noopener noreferrer' } : {};
    const backgroundImage =
      featured_media && featured_media.src
        ? featured_media.src
        : getPublicAssets('/img/trash/home-ffr/Prochain_match@2x.jpg');

    return (
      this.props.datas && (
        <div className="mb-2 mb-lg-4">
          <div className="box card card--nextgame card--large">
            <BackgroundImage
              className="card__thumbnail img-blue-dark"
              illustration={backgroundImage}
              srcset={featured_media && featured_media.sizes}
              forceState={'large'}
            />
            <h3 className="card__title">
              <a href={link} title="Voir le prochain match">
                Prochain match
              </a>
            </h3>
            <div className="card__body">
              <a href={link} title="Voir le prochain match">
                <p className="ft-h6 mb-2 mb-md-1 mb-lg-2 ft-up">{competition}</p>
                <div className="match">
                  <div className="match__club">
                    <p className="ft-h3 ft-400">
                      {reception ? 'France' : adversaire}
                      {reception ? (
                        <img
                          src={embleme_france ? embleme_france : this.props.datas.defaultImgTeam}
                          alt=""
                          width="24"
                          height="24"
                        />
                      ) : (
                        <img
                          src={embleme_adversaire ? embleme_adversaire : this.props.datas.defaultImgTeam}
                          alt=""
                          width="24"
                          height="24"
                        />
                      )}
                    </p>
                  </div>

                  <div className="match__info">
                    <p className="match__time ft-700  ft-up">
                      {formatFullDateString(getDateFromString(date_rencontre))}
                      <br /> {formatHours(getDateFromString(date_rencontre))}
                    </p>
                  </div>

                  <div className="match__club">
                    <p className="ft-h3 ft-400">
                      {reception ? adversaire : 'France'}
                      {reception ? (
                        <img
                          src={embleme_adversaire ? embleme_adversaire : this.props.datas.defaultImgTeam}
                          alt=""
                          width="24"
                          height="24"
                        />
                      ) : (
                        <img
                          src={embleme_france ? embleme_france : this.props.datas.defaultImgTeam}
                          alt=""
                          width="24"
                          height="24"
                        />
                      )}
                    </p>
                  </div>
                </div>
                <p className="card__desc ft-h6 mb-0 ft-up">{lieu}</p>
              </a>
            </div>

            <div className="card__footer">
              {billetterie && (
                <a href={billetterie} {...url_attributes}>
                  <span
                    role="button"
                    tabIndex={0}
                    className="btn btn--primary btn--full"
                    onClick={this.onBilletterieClick(adversaire, reception)}
                  >
                    <i className="icon icon-ticket is-inline"></i>
                    <span>Acheter vos billets</span>
                  </span>
                </a>
              )}
            </div>
          </div>
        </div>
      )
    );
  }
}

export default TeamMenuNextMatch;
